import { CreateCommentDto } from '@sr/dto';
import { commentsApi } from 'entities/comments/api';
import { Comments } from 'entities/comments';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { CardPaperTitled } from 'shared/ui/card-paper';

export const LeadComments = ({ id }: { id: number; }) => {
  const { data, error, isLoading } = commentsApi.useFetchLeadCommentQuery(id);
  const [postComment] = commentsApi.usePostLeadCommentMutation();

  const handleAddComment = async (dto: CreateCommentDto) => {
    await postComment({ leadId: id, dto }).unwrap();
  };

  return (
    <CardPaperTitled title="Комментарии" sx={{ marginTop: 2 }}>
      <Comments
        comments={data}
        isLoading={isLoading}
        error={extractNestJsErrorMessage(error)}
        addComment={handleAddComment} />
    </CardPaperTitled>
  )
};
